<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../../services/i18n';
	import { gen2Request } from '../../../../../services/gen_2_http_reqs';
	//Stores
		//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Types
	import type { SettingRequest } from '../../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Radio, Text, toast } from '@Shelly/shelly-design-system';
	import { real_id } from 'src/helpers/interface_helpers';

	$: settingsStore = getDeviceSettings(device.id);
	export let device;
	const inputOptions = ['follow', 'flip'];
	const _input_options_i18n = [
		$format('btn_mode_follow_scc_toast', { default: 'follow' }),
		$format('btn_mode_flip_scc_toast', { default: 'flip' }),
	]; //using this already done translation keys just to not add new ones but if needed i will

	let settings = $settingsStore;
	let value = settings[`switch:0`].in_mode;
	let loading = false;
	let cache = value;

	const disabled = settings?.['input:0']?.type !== 'switch'; //if the input is not switch this option is not available. In near future if we have a mechanism to disable or hide this setting we will rework this.

	const setInputType = (_value) => {
		value = _value;
	};

	const sentRequest = async () => {
		//if the input is switch
		/**
		 * method: "switch.setconfig"
		 * params: {id: 0, config: {in_mode: "flip"}}
		 * src: "8b85c5c6-f051-450d-8295-c31bd54e1abe"
		 */
		/**
		 * method: "switch.setconfig"
		 * params: {id: 0, config: {initial_state: "match_input", in_mode: "follow"}}
		 */
		//if the input is button or disabled this option is not available so options will be disabled
		try {
			if (cache !== value) {
				loading = true;
				let params = {
					id: 0,
					config: {
						initial_state: value !== 'follow' ? 'restore_last' : 'off', //inside the embedded web there is a error, which isn't handled. It sends "match_input" instead of "restore_last", which isn't supported.
						in_mode: value,
					},
				};

				const res: SettingRequest = await gen2Request(device, 'Switch.SetConfig', params);

				if (res.isok) {
					settings[`switch:0`].in_mode = value;
					cache = value;
				} else {
					toast.open({
						type: 'danger',
						title:
							$format('output_type_err_toast') || 'Error! Could not change output mode.',
					});
					value = cache;
					throw new Error('Could not change output mode.');
				}
				toast.open({
					type: 'success',
					title: $format('output_type_scc_toast', {
						default: `Output mode changed to {mode_value}`,
						values: { mode_value: value },
					}),
				});
				loading = false;
			}
		} catch (error) {
			console.error(error);
		}
	};
</script>

<Text element="h2" styleType="h2" class="mb-s">
	{$format('output_type_desc', { default: 'Set output type' })}
</Text>

{#each inputOptions as option, index}
	<Radio
		size="m"
		selected={option}
		{value}
		{disabled}
		on:click={() => setInputType(option)}
		id="radio-v7vo2mz"
	>
		{capFirstChar(_input_options_i18n[index])}
	</Radio>
{/each}

<Button class="mt-s" {disabled} {loading} size="m" width="full" on:click={sentRequest}>
	{$format('button_save')}
</Button>
